'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderColor',
  key: 'colors'
});


//////////////////
// WEBPACK FOOTER
// ./~/rebass/~/styled-system/dist/border-color.js
// module id = 1273
// module chunks = 0